import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6v13","key":"svg-0"}],["path",{"d":"M20 6v13","key":"svg-1"}]]

const IconLane = createReactComponent('outline', 'lane', 'Lane', __iconNode);

export default IconLane;